import { _animate } from "../utils/_animate";
import { _lazyLoad } from "../utils/_lazyLoad";
import { _parallax, _parallaxScroller } from "../utils/_parallax";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

class OurApproachV2 extends MainClass {
    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.init();
    }

    init() {
        // for lazyload
        _lazyLoad();

        // for animate
        new _animate();

        const _title = this.selector.querySelector(".js-our-approach-v2-title") as HTMLElement;
        if (_title) {
            const _highlighted = _title.querySelectorAll("i, span") as NodeListOf<HTMLElement>;
            if (_highlighted.length <= 0) return;

            _highlighted.forEach((item) => {
                new _parallaxScroller({
                    target: _title,
                    init: () => {
                        item.style.setProperty("-webkit-text-fill-color", "transparent");
                    },
                    resize: (scroller) => {
                        const _offset = _parallax.getOffset(scroller.target);

                        scroller.offset.top = _offset.top - window.innerHeight * 0.6;
                        scroller.offset.bottom = _offset.bottom - window.innerHeight * 0.6;
                    },
                    update: (scroller) => {
                        const _percent = Math.round(_parallax.abs(scroller.offset.current) * 100);

                        item.style.setProperty("--percent", `${_percent}%`);
                    },
                });
            });
        }

        // console.log("OurApproachV2", this);
    }
}

export default OurApproachV2;
